const dataLayer = window.dataLayer;

const Events = {
  Actions: "el_cert_actions"
};

const Actions = {
  WelcomeCompanySettingLanding: "welcome_company_setting_landing",
  WelcomeCompanySettingDone: "welcome_company_setting_done",
  WelcomeStampSubmitterSettingLanding: "welcome_stamp_submitter_setting_landing",
  WelcomeStampSubmitterSettingDone: "welcome_stamp_submitter_setting_done",
  HomeToEntryNew: "home_to_entry_new",
  EntryNewToConfirm: "entry_new_to_confirm",
  EntryConfirmToModal: "entry_confirm_to_modal",
  EntryModalToComplete: "entry_modal_to_complete",
};

class AnalyticWrapper {
  constructor() {
    this.metaData = {};
  }

  pushData = data => {
    dataLayer.push(data);
    this.metaData = { ...this.metaData, ...data };
  };

  sendLog = content => {
    dataLayer.push(content);
    try {
      if (process.env.REACT_APP_ENVIRONMENT !== "production") {
        console.log(content);
      }
    } catch (e) {
      // ignore
    }
  };

  sendActions = content =>
    this.sendLog({
      ...content,
      event: Events.Actions
    });

  welcomeCompanySettingLanding = isNewUser =>
    this.sendActions({ action: Actions.WelcomeCompanySettingLanding, isNewUser });
  welcomeCompanySettingDone = isNewUser =>
    this.sendActions({ action: Actions.WelcomeCompanySettingDone, isNewUser });
  welcomeStampSubmitterSettingLanding = isNewUser =>
    this.sendActions({ action: Actions.WelcomeStampSubmitterSettingLanding, isNewUser });
  welcomeStampSubmitterSettingDone = isNewUser =>
    this.sendActions({ action: Actions.WelcomeStampSubmitterSettingDone, isNewUser });
  homeToEntryNew = isNewUser =>
    this.sendActions({ action: Actions.HomeToEntryNew, isNewUser });
  entryNewToConfirm = isNewUser =>
    this.sendActions({ action: Actions.EntryNewToConfirm, isNewUser });
  entryConfirmToModal = isNewUser =>
    this.sendActions({ action: Actions.EntryConfirmToModal, isNewUser });
  entryModalToComplete = isNewUser =>
    this.sendActions({ action: Actions.EntryModalToComplete, isNewUser });
}

const Analytics = new AnalyticWrapper();

export default Analytics;
